import React from 'react';
import { observer } from 'mobx-react';

const Loader = observer(class Loader extends React.Component {
  render() {
    const { store } = this.props;

    return(
      <div className={`loader ${store.SessionStore.loadingClass}`}>
        <strong className="loader__msg"><span className="meta">{store.SessionStore.loadingMessage}</span></strong>
      </div>
    );
  }
})

export default Loader;


// WEBPACK FOOTER //
// ./src/app/components/Common/Loader.js